import React, { useState } from "react";
import styled from "styled-components";
import Button from "./Common/Button";
import CategoryAnswers from "./CategoryAnswers";
import { usePlayersContext, useSocketContext } from "./Common/Contexts";
import { useTranslationContext } from "../Hooks/useTranslationContext";
import Help from "./Help";
import PointsLegend from "./PointsLegend";
import { ConfirmPopup } from "./Common/Popup";
import { ScoreBoardWithPointsThisTurn } from "./ScoreBoard";
import Answer from "../Types/Answer";
import Game from "../Types/Game";

const Footer = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr 4fr;
`;

const FlexContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

interface RoundReviewProps {
  gameId: number;
  game: Game;
  answers: { [socketId: string]: Answer[] };
}

const RoundReview = ({ game, answers, gameId }: RoundReviewProps) => {
  const socket = useSocketContext();
  const { t } = useTranslationContext();
  const { players } = usePlayersContext();
  const [socketIdToRemove, setSocketIdToRemove] = useState<string>();
  const handleReady = () => socket.emit("playerReady", gameId);
  const handleOnTryToRemovePlayer = (socketId: string) =>
    setSocketIdToRemove(socketId);
  const handleOnRemovePlayer = (socketId: string) =>
    socket.emit("removePlayer", gameId, socketId);
  const handleonPointChange = (
    socketId: string,
    category: string,
    value: number
  ) => socket.emit("overridePoint", { gameId, socketId, category, value });
  const thisPlayerReady = players[socket.id].isReady;
  return (
    <div>
      <CategoryAnswers
        categories={game.categories.map((c) => c.name)}
        answers={answers}
        players={game.socketIds}
        handleonPointChange={handleonPointChange}
      />
      <ScoreBoardWithPointsThisTurn
        answers={answers}
        gameSocketIds={game.socketIds}
        handleOnRemovePlayer={handleOnTryToRemovePlayer}
        playerIdThatFinishedRound={game.playerIdThatFinishedRound}
      />
      {socketIdToRemove && (
        <ConfirmPopup
          onCancel={() => setSocketIdToRemove(undefined)}
          onSubmit={() => {
            handleOnRemovePlayer(socketIdToRemove);
            setSocketIdToRemove(undefined);
          }}
          message={t["do.you.really.want.to.remove"](
            players[socketIdToRemove].name ?? t["this.player"]
          )}
        />
      )}
      <Footer>
        <div></div>
        <Button onClick={handleReady} disabled={thisPlayerReady}>
          {t.ready}
        </Button>
        <FlexContainer>
          <Help>
            <PointsLegend />
          </Help>
        </FlexContainer>
      </Footer>
    </div>
  );
};

export default RoundReview;
